"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _refundOrderDetail = _interopRequireDefault(require("./refundOrderDetail"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@/utils");
var _product = require("@/api/product");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'orderRefund',
  components: {
    detailsFrom: _refundOrderDetail.default
  },
  data: function data() {
    return {
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      refundVisible: false,
      refundGoodsVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      refundGoodsFrom: {
        refundAddress: '',
        refundName: '',
        refundTel: '',
        refundOrderNo: '',
        zipCode: ''
      },
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        refundStatus: '9',
        dateLimit: '',
        orderNo: '',
        refundOrderNo: '',
        page: 1,
        limit: 20
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['退款单号', '订单号', '用户信息', '退款金额', '退款状态', '创建时间'],
      columnData: ['退款单号', '订单号', '用户信息', '退款金额', '退款状态', '创建时间'],
      isIndeterminate: true
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:refund:order:page:list'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:refund:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 拒绝退款
    RefusehandleClose: function RefusehandleClose() {
      this.RefuseVisible = false;
    },
    onOrderRefuse: function onOrderRefuse(row) {
      var _this = this;
      this.$modalPrompt('textarea', '拒绝退款原因').then(function (V) {
        (0, _order.orderRefuseApi)({
          reason: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this.$message.success('操作成功');
          _this.getList();
        });
      });
    },
    RefusehandlerSubmit: function RefusehandlerSubmit(formValue) {
      var _this2 = this;
      (0, _order.orderRefuseApi)({
        refundOrderNo: formValue.refundOrderNo,
        reason: formValue.reason
      }).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.RefuseVisible = false;
        _this2.getList();
      });
    },
    // 立即退款
    refundhandleClose: function refundhandleClose() {
      this.refundVisible = false;
    },
    onOrderRefund: function onOrderRefund(row) {
      var _this3 = this;
      this.$modalSure('您确定要进行退款吗？').then(function () {
        (0, _order.orderRefundApi)({
          refundOrderNo: row.refundOrderNo
        }).then(function (data) {
          _this3.$message.success('操作成功');
          _this3.tableFrom.page = 1;
          _this3.getList();
        });
      });
    },
    onOrderRefundGoods: function onOrderRefundGoods(row) {
      this.refundGoodsVisible = true;
      this.refundGoodsFrom.refundOrderNo = row.refundOrderNo;
    },
    refundhandlerSubmit: function refundhandlerSubmit(formValue) {
      var _this4 = this;
      (0, _order.orderRefundApi)({
        refundOrderNo: this.orderids
      }).then(function (data) {
        _this4.$message.success('操作成功');
        _this4.refundVisible = false;
        _this4.tableFrom.page = 1;
        _this4.getList();
      });
    },
    refundGoodsHandlerSubmit: function refundGoodsHandlerSubmit() {
      var _this5 = this;
      (0, _order.orderGoodsRefundApi)(this.refundGoodsFrom).then(function (data) {
        _this5.$message.success('操作成功');
        _this5.refundGoodsVisible = false;
        _this5.tableFrom.page = 1;
        _this5.getList();
      });
    },
    // 详情
    onOrderDetails: function onOrderDetails(row) {
      this.orderNo = row.supplierMainOrderNo;
      this.$refs.orderDetail.getDetail(row.refundOrderNo);
      this.$refs.orderDetail.getRefundOrderDetail(row.refundOrderNo);
      this.$refs.orderDetail.getOrderInvoiceList(row.supplierMainOrderNo);
      this.$refs.orderDetail.dialogVisible = true;
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this6 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      (0, _order.orderLogApi)(this.tableFromLog).then(function (res) {
        _this6.tableDataLog.data = res.list;
        _this6.tableDataLog.total = res.total;
        _this6.LogLoading = false;
      }).catch(function () {
        _this6.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this7 = this;
      this.$modalPrompt('textarea', '退款单备注', row.merRemark).then(function (V) {
        (0, _order.refundMarkApi)({
          remark: V,
          refundOrderNo: row.refundOrderNo
        }).then(function () {
          _this7.$message.success('操作成功');
          _this7.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
      // this.getOrderListData();
    },
    // 列表
    getList: function getList() {
      var _this8 = this;
      this.listLoading = true;
      (0, _order.refundListApi)(this.tableFrom).then(function (res) {
        _this8.tableData.data = res.list || [];
        _this8.tableData.total = res.total;
        _this8.listLoading = false;
        _this8.checkedCities = _this8.$cache.local.has('order_stroge') ? _this8.$cache.local.getJSON('order_stroge') : _this8.checkedCities;
      }).catch(function () {
        _this8.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this9 = this;
      (0, _order.refundStatusNumApi)({
        dateLimit: this.tableFrom.dateLimit
      }).then(function (res) {
        _this9.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        refundStatus: this.tableFrom.status,
        type: this.tableFrom.type
      };
      (0, _product.orderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    renderHeader: function renderHeader(h) {
      var _this0 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this0.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this1 = this;
      (0, _order.orderPrint)(data.orderNo).then(function (res) {
        _this1.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this1.$modal.msgError(error.message);
      });
    }
  }
};